import { AxiosError } from 'axios';

/**
 * Vrai lorsqu'une erreur de requête API correspond à une donnée NON disponible
 * côté backend : HTTP 503 (DataUnavailableError, `code:
 * AUTHORITATIVE_DATA_UNAVAILABLE`). L'écran doit alors afficher le placeholder
 * « fonction en cours d'activation ».
 *
 * Remplace le blocage figé au build (`IS_PRODUCTION`) : la disponibilité d'une
 * fonctionnalité est désormais pilotée par la RÉPONSE du backend — si la source
 * réelle est branchée, le backend renvoie 200 et l'écran affiche les vraies
 * valeurs ; sinon il renvoie 503 et l'écran l'indique honnêtement.
 */
export function isDataUnavailable(error: unknown): boolean {
  return (error as AxiosError | null | undefined)?.response?.status === 503;
}
